import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AccessGate from './components/AccessGate';
import Dashboard from './components/Dashboard';
import ModuleOne from './components/modules/ModuleOne';
import ModuleTwo from './components/modules/ModuleTwo';
import ModuleThree from './components/modules/ModuleThree';
import ModuleFour from './components/modules/ModuleFour';
import ModuleFive from './components/modules/ModuleFive';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [moduleData, setModuleData] = useState({
    module1: { completed: false, data: {} },
    module2: { completed: false, data: {} },
    module3: { completed: false, data: {} },
    module4: { completed: false, data: {} },
    module5: { completed: false, data: {} }
  });

  useEffect(() => {
    const auth = localStorage.getItem('plannedWithPurpose_auth');
    const savedData = localStorage.getItem('plannedWithPurpose_data');
    
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    
    if (savedData) {
      setModuleData(JSON.parse(savedData));
    }
  }, []);

  const saveModuleData = (moduleKey, data, completed = false) => {
    const newModuleData = {
      ...moduleData,
      [moduleKey]: {
        completed,
        data: { ...moduleData[moduleKey].data, ...data },
        lastUpdated: new Date().toISOString()
      }
    };
    setModuleData(newModuleData);
    localStorage.setItem('plannedWithPurpose_data', JSON.stringify(newModuleData));
  };

  const handleLogout = () => {
    localStorage.removeItem('plannedWithPurpose_auth');
    setIsAuthenticated(false);
  };

  const calculateProgress = () => {
    const completedModules = Object.values(moduleData).filter(module => module.completed).length;
    return Math.round((completedModules / 5) * 100);
  };

  if (!isAuthenticated) {
    return <AccessGate onAuthenticate={() => setIsAuthenticated(true)} />;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <Routes>
          <Route 
            path="/" 
            element={
              <Dashboard 
                moduleData={moduleData} 
                progress={calculateProgress()} 
                onLogout={handleLogout}
              />
            } 
          />
          <Route 
            path="/module-1" 
            element={
              <ModuleOne 
                data={moduleData.module1.data}
                onSave={(data, completed) => saveModuleData('module1', data, completed)}
                completed={moduleData.module1.completed}
              />
            } 
          />
          <Route 
            path="/module-2" 
            element={
              <ModuleTwo 
                data={moduleData.module2.data}
                onSave={(data, completed) => saveModuleData('module2', data, completed)}
                completed={moduleData.module2.completed}
              />
            } 
          />
          <Route 
            path="/module-3" 
            element={
              <ModuleThree 
                data={moduleData.module3.data}
                onSave={(data, completed) => saveModuleData('module3', data, completed)}
                completed={moduleData.module3.completed}
              />
            } 
          />
          <Route 
            path="/module-4" 
            element={
              <ModuleFour 
                data={moduleData.module4.data}
                onSave={(data, completed) => saveModuleData('module4', data, completed)}
                completed={moduleData.module4.completed}
              />
            } 
          />
          <Route 
            path="/module-5" 
            element={
              <ModuleFive 
                data={moduleData.module5.data}
                onSave={(data, completed) => saveModuleData('module5', data, completed)}
                completed={moduleData.module5.completed}
              />
            } 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;